module.exports = __webpack_public_path__ + "img/1479634263.e67d9383.jpg";